import React from 'react';
import ReservationForm from './ReservationForm';

export default function AddReservation() {
  return <ReservationForm />;
}
